import {
	Home6, Theme6Introduction, Theme6SubtopicOneActivityOne, Theme6SubtopicOneFinalPoints,
	Theme6SubtopicTwoActivityOne, Theme6SubtopicTwoActivityTwo, Theme6SubtopicTwoActivityThree, Theme6SubtopicTwoFinalPoints,
	Theme6SubtopicThreeActivityOne, Theme6SubtopicThreeActivityTwo, Theme6SubtopicThreeActivityThree, Theme6SubtopicThreeFinalPoints,
	Theme6SubtopicFourActivityOne, Theme6SubtopicFourActivityTwo, Theme6SubtopicFourActivityThree, Theme6SubtopicFourFinalPoints,
	Theme6SubtopicFiveActivityOne, Theme6SubtopicFiveActivityTwo, Theme6SubtopicFiveActivityThree, Theme6SubtopicFiveActivityFour, Theme6SubtopicFiveFinalPoints,
	SubtopicFinalTema6,
} from "../pages/tema6";



export const pathTeam6 = {
	path: "home6",
	element: <Home6 />,
	children: [
		{
			path: "tema6",
			children: [
				{
					path: "introduction",
					element: <Theme6Introduction />,
				},
				{
					path: "subtema1",
					children: [
						{
							path: "activityOne",
							element: <Theme6SubtopicOneActivityOne />,
						},
						{
							path: "activityresult",
							element: <Theme6SubtopicOneFinalPoints />,
						},
					],
				},
				{
					path: "subtema2",
					children: [
						{
							path: "activityOne",
							element: <Theme6SubtopicTwoActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Theme6SubtopicTwoActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Theme6SubtopicTwoActivityThree />,
						},
						{
							path: "activityresult",
							element: <Theme6SubtopicTwoFinalPoints />,
						},
					],
				},
				{
					path: "subtema3",
					children: [
						{
							path: "activityOne",
							element: <Theme6SubtopicThreeActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Theme6SubtopicThreeActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Theme6SubtopicThreeActivityThree />,
						},
						{
							path: "activityresult",
							element: <Theme6SubtopicThreeFinalPoints />,
						},
					],
				},
				{
					path: "subtema4",
					children: [
						{
							path: "activityOne",
							element: <Theme6SubtopicFourActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Theme6SubtopicFourActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Theme6SubtopicFourActivityThree />,
						},
						{
							path: "activityresult",
							element: <Theme6SubtopicFourFinalPoints />,
						},
					],
				},
				{
					path: "subtema5",
					children: [
						{
							path: "activityOne",
							element: <Theme6SubtopicFiveActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Theme6SubtopicFiveActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Theme6SubtopicFiveActivityThree />,
						},
						{
							path: "activityFour",
							element: <Theme6SubtopicFiveActivityFour />,
						},
						{
							path: "activityresult",
							element: <Theme6SubtopicFiveFinalPoints />,
						},
					],
				},
				{
					path: "final",
					element: <SubtopicFinalTema6 />,
				},
			],
		}
	]
}